import { render, staticRenderFns } from "./MeetingDocumentsDocsStatuses.vue?vue&type=template&id=0159b142&"
import script from "./MeetingDocumentsDocsStatuses.vue?vue&type=script&lang=js&"
export * from "./MeetingDocumentsDocsStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports